import { Component, Input, OnInit } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import { WaterMark } from 'src/app/shared/water-mark';
import { OldChulaLogo_Base64 } from 'src/app/shared/old-chula-logo-base64';
import { Signature } from 'src/app/shared/signature';
import THBText from 'thai-baht-text'
import { DatePipe } from 'src/app/shared/pipe/date.pipe';

@Component({
  selector: 'lifedi-print-receipt-agency',
  templateUrl: './print-receipt-agency.component.html',
  styleUrls: ['./print-receipt-agency.component.scss']
})
export class PrintReceiptAgencyComponent implements OnInit {
  @Input() printDetail;

  printData: any;
  titleType: string;

  constructor() { }

  ngOnInit(): void {
    // console.log(this.printDetail);
    this.printData = this.printDetail.printData;
    this.titleType = this.printDetail.titleType;
    this.print();
  }

  print() {
    let receiptDetails;
    let today = new Date();

    receiptDetails = {
      address: `จุดรับเงิน: คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย
      อาคารบรมราชชนนีศรีศตพรรษ ชั้น 7 แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330
      โทรศัพท์: 02-218-1185 โทรสาร: 02-218-1339 เลขที่ผู้เสียภาษี: 0994000163860 สาขา: 3800`,
      number: `เลขที่ใบเสร็จ ${this.printData.detail.RECEIPT_NO}`,
      account_id: this.printData.detail.ACCOUNTING_ID,
      account: this.printData.detail.ACCOUNTING_NAME,
      customer_name: this.printData.detail.CUSTOMER_NAME,
      customer_detail: this.printData.detail.CUSTOMER_DETAIL,
      taxId: this.printData.detail.TAX_NO,
      date: new DatePipe().transform(this.printData.detail.CREATE_DATE.toString(), 'full'),
      tableDetail: this.printData.detail.reDetail,
      thbaht: this.printData.price.totalNetPrice > 0 ? THBText(this.printData.price.totalNetPrice) : 'ฟรี',
      signaturePic1: Signature[0].signature,
      signatureName1: Signature[0].signatureName,
      signatureJobTitle1: Signature[0].position,
      signaturePic2: Signature[1].signature,
      signatureName2: Signature[1].signatureName,
      signatureJobTitle2: Signature[1].position,
      total: this.printData.price.total,
      discount: this.printData.price.discount,
      priceWithoutVat: this.printData.price.priceWithoutVat,
      vatPrice: this.printData.price.vatPrice,
      totalNetPrice: this.printData.price.totalNetPrice,
      printDate: `${new DatePipe().transform(today.toString(), 'full')} - ${today.getHours() > 9 ? '' : 0}${today.getHours()}:${today.getMinutes() > 9 ? '' : 0}${today.getMinutes()} น.`,
      printType: this.printDetail.printType === 'original' ? '(ต้นฉบับ)' : '(สำเนา)',
      receiptType: this.printData.detail.RECEIPT_TYPE,
      createType: this.printData.detail.CREATE_TYPE,
      billAmount: this.printData.detail.BILLED_AMOUNT,
      partialThbaht: THBText(this.printData.detail.BILLED_AMOUNT),
      note: this.printData.note,
    }

    this.openPdf(receiptDetails);
  }

  openPdf(detail) {
    // console.log(detail);

    let documentDefinition,
      tableBody = [],
      fullMargin = [40, 265, 40, 180],
      shortMargin = [40, 180, 40, 180],
      margin,
      customerColumn,
      totalTable = [],
      noteTable = [],
      borderColor = ['#959595', '#959595', '#959595', '#959595'],
      THBaht = detail.createType === 'Partial' ? detail.partialThbaht : detail.thbaht;

    margin = detail.receiptType === 'Full' ? fullMargin : shortMargin;
    customerColumn = detail.receiptType === 'Full' ? [
      {
        stack: [
          `ชื่อลูกค้า: ${detail.customer_name}`,
          `ข้อมูลลูกค้า: ${detail.customer_detail}`,
          `เลขประจำตัวผู้เสียภาษี: ${detail.taxId}`,
        ],
        style: 'userSubDetail',
        width: 220,

      },
    ] : [];

    tableBody = [[
      { text: 'เลขที่', style: 'tableHeader', borderColor: borderColor, },
      { text: 'รายการ', style: 'tableHeader', borderColor: borderColor, },
      { text: 'จำนวน', style: 'tableHeader', borderColor: borderColor, },
      { text: 'ราคาต่อหน่วย', style: 'tableHeader', borderColor: borderColor, },
      { text: 'ส่วนลด', style: 'tableHeader', borderColor: borderColor, },
      { text: 'จำนวนเงิน (บาท)', style: 'tableHeader', borderColor: borderColor, },
    ]];

    detail.tableDetail.forEach((e, i) => {
      tableBody.push(
        [
          { text: e.ITEM_NUM, margin: [5, 3], fontSize: 12, alignment: 'center', borderColor: borderColor, },
          { text: e.DESCRIPTION, margin: [5, 3], style: 'tableList', borderColor: borderColor, },
          { text: e.QTY, margin: [5, 3], fontSize: 12, alignment: 'center', borderColor: borderColor, },
          { text: e.UNIT_PRICE.toLocaleString(undefined, { minimumFractionDigits: 2 }), style: 'tableNumber', borderColor: borderColor, },
          { text: e.DISCOUNT.toLocaleString(undefined, { minimumFractionDigits: 2 }), style: 'tableNumber', borderColor: borderColor, },
          { text: e.TOTAL.toLocaleString(undefined, { minimumFractionDigits: 2 }), style: 'tableNumber', borderColor: borderColor, },
        ],
      )
    });

    if (detail.createType === 'Partial') {
      totalTable = [
        // tableBody.push(
        [
          { text: 'รวมเงิน', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.total.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: 'ส่วนลด', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.discount.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: `ราคาไม่รวมภาษีมูลค่าเพิ่ม`, style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.priceWithoutVat.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: 'ภาษีมูลค่าเพิ่ม (7%)', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.vatPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: 'ราคารวมสุทธิ', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.totalNetPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: 'แบ่งชำระ', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.billAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: 'จำนวนเงินทั้งสิ้น', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.billAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        // )
      ]
    } else {
      totalTable = [
        // tableBody.push(
        [
          { text: 'รวมเงิน', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.total.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: 'ส่วนลด', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.discount.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: `ราคาไม่รวมภาษีมูลค่าเพิ่ม`, style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.priceWithoutVat.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: 'ภาษีมูลค่าเพิ่ม (7%)', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.vatPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        [
          { text: 'ราคารวมสุทธิ', style: 'tableTextTotal', borderColor: borderColor, border: [true, true, true, true], },
          { text: detail.totalNetPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }), border: [true, true, true, true], style: 'tableTotal', borderColor: borderColor, },
        ],
        // )
      ]
    }

    noteTable = [
      [
        { text: 'หมายเหตุ:', border: [true, true, true, false], borderColor: borderColor, style: 'noteTableStyle' },
      ],
      [
        { text: detail.note, border: [true, false, true, true], borderColor: borderColor, style: 'noteTableStyle' },
      ],
    ];

    pdfMake.fonts = {
      THsarabunNew: {
        normal: 'THSarabun.ttf',
        bold: 'THSarabunNew Bold.ttf',
        italics: 'THSarabunNew Italic.ttf',
        bolditalics: 'THSarabunNew BoldItalic.ttf',
      },
    };

    documentDefinition = {
      background: [
        {
          image: WaterMark,
          width: 300,
          absolutePosition: { x: 150, y: 250 },
          opacity: 0.15
        }
      ],
      header: [
        {
          columns: [
            [
              {
                image: OldChulaLogo_Base64,
                width: 100,
                style: 'logoChulaHeader'
              },
            ],
          ]
        },
        {
          columns: [
            {
              stack: [
                `${detail.number}`,
                `วันที่ ${detail.date}`,
                `${detail.printType}`,
              ]
            },
          ],
          style: 'printHeader'
        },
        {
          columns: [
            [
              {
                text: 'จุฬาลงกรณ์มหาวิทยาลัย',
                style: 'textHeader'
              },
              {
                text: this.titleType,
                style: 'subTextHeader'
              },
              {
                text: detail.address,
                style: 'addressHeader'
              },
            ],
          ]
        },
        {
          columns: customerColumn
        },
      ],

      footer: function (currentPage, pageCount) {
        if (currentPage == pageCount) {
          return [
            {
              columns: [
                [
                  {
                    // image: detail.signaturePic1,
                    text: '',
                    width: '*',
                    // width: 100,
                    // height: 25,
                    margin: [-10, 0, -40, 0],
                    alignment: 'center',
                  },
                  {
                    text: '_________________________',
                    width: '*',
                    margin: [-10, 0, -80, 0],
                    alignment: 'center',
                    bold: true,
                  },
                  {
                    // text: detail.signatureJobTitle1,
                    text: 'หัวหน้าหน่วยรับเงิน',
                    width: '*',
                    margin: [-10, 0, -80, 0],
                    alignment: 'center',
                    bold: true,
                  },
                  {
                    text: `(                             )`,
                    // text: `(${detail.signatureName1})`,
                    width: '*',
                    margin: [-10, 0, -80, 0],
                    alignment: 'center',
                    bold: true,
                  },
                ],
                [
                  {
                    text: '', // blank column
                  }
                ],
                [
                  {
                    text: '', // blank column
                  }
                ],
                [
                  {
                    // image: detail.signaturePic2,
                    // width: 100,
                    // height: 25,
                    text: '',
                    width: '*',
                    margin: [-70, 0, 35, 0],
                    alignment: 'center',
                  },
                  {
                    text: '_________________________',
                    width: '*',
                    margin: [-70, 0, 0, 0],
                    alignment: 'center',
                    bold: true,
                  },
                  {
                    text: 'ผู้รับเงิน',
                    // text: detail.signatureJobTitle2,
                    width: '*',
                    margin: [-70, 0, 0, 0],
                    alignment: 'center',
                    bold: true,
                  },
                  {
                    // text: `(${detail.signatureName2})`,
                    text: `(                             )`,
                    width: '*',
                    margin: [-70, 0, 0, 0],
                    alignment: 'center',
                    bold: true,
                  },
                ],
              ]
            },
            {
              columns: [
                [
                  {
                    text: `(ใบเสร็จรับเงินจะมีผลสมบูรณ์ก็ต่อเมื่อได้รับชำระเงินเรียบร้อยแล้ว และมีลายชื่อของหัวหน้าหน่วยรับเงินและผู้รับเงิน)
                ถ้าชำระด้วยเช็ค ใบเสร็จรับเงินจะสมบูรณ์ก็ต่อเมื่อได้รับเงินตามเช็คนั้นเรียบร้อยแล้ว
                หมายเหตุ: จุฬาลงกรณ์มหาวิทยาลัยโดยกรมบัญชีกลางพิจารณาให้ระบบลายมือชื่ออิเล็กทรอนิกส์อยู่ในอำนาจของสภามหาวิทยาลัย
                ตามพระราชบัญญัติจุฬาลงกรณ์มหาวิทยาลัย ตามหนังสือที่ กค 0402.2/54154 ลงวันที่ 22 พฤศจิกายน 2562`,
                    alignment: 'center',
                    margin: [0, 10, 0, 0]
                  },
                ]
              ]
            },
            {
              columns: [
                {
                  text: `พิมพ์เมื่อ: ${detail.printDate}`,
                  alignment: 'left',
                  margin: [40, 15, 0, 0]
                },
              ]
            },
            {
              columns: [
                {
                  text: `หน้า ${currentPage.toString()} จาก ${pageCount}`,
                  alignment: 'center',
                  margin: [0, -13, 0, 0]
                }
              ]
            },
          ];
        } else {
          return [
            {
              text: `หน้า ${currentPage.toString()} จาก ${pageCount}`,
              alignment: 'center',
              margin: [0, 86, 0, 0]
            }
          ];
        }
      },
      content: [
        {
          table: {
            headerRows: 1,
            widths: [25, 225, 35, 52, 43, 80],
            heights: [0, 0, 0],
            body: tableBody
          }
        },
        {
          columns: [
            {
              margin: [0, -1, -21, 0],
              table: {
                // headerRows: 1,
                widths: [303],
                heights: [10, 53.9],
                body: noteTable
              }
            },
            {
              margin: [0, -1, 0, 0],
              table: {
                // headerRows: 1,
                widths: [104, 80],
                // heights: [0, 0, 0],
                body: totalTable
              }
            },
          ],
        },
        {
          columns: [
            {
              text: `จำนวนเงินรวม (ตัวอักษร) ${THBaht}`,
              bold: true,
              margin: [0, -15, 0, 0],
            },
          ],
        },
      ],
      styles: {
        logoChulaHeader: {
          margin: [0, 35, 0, 5],
          alignment: 'center'
        },
        printHeader: {
          margin: [0, -55, 43, 5],
          alignment: 'right',
          // color: '#A5A5A5'
        },
        textHeader: {
          margin: [0, 5, 0, 0],
          alignment: 'center',
          fontSize: 20,
          bold: true,
        },
        subTextHeader: {
          margin: [0, -5, 0, 0],
          alignment: 'center',
          fontSize: 18,
          bold: true,
        },
        addressHeader: {
          margin: [0, 0, 0, 0],
          alignment: 'center',
          // fontSize: ,
        },
        userSubDetail: {
          margin: [43, 0, 0, 5],
          alignment: 'left',
          bold: true,
        },
        tableHeader: {
          margin: [0, 0, 0, 0],
          bold: true,
          fontSize: 13,
          alignment: 'center'
        },
        tableNumber: {
          margin: [5, 3],
          fontSize: 12,
          alignment: 'right'
        },
        tableList: {
          margin: [5, 3],
          fontSize: 12,
          alignment: 'left'
        },
        tableTextTotal: {
          margin: [5, 0],
          fontSize: 13,
          alignment: 'right'
        },
        tableTotal: {
          margin: [5, 0],
          fontSize: 13,
          alignment: 'right'
        },
        noteTableStyle: {
          margin: [5, 0]
        }
      },
      defaultStyle: {
        columnGap: 20,
        font: 'THsarabunNew'
      },
      pageMargins: margin,
      // pageMargins: [40, 255, 40, 120],
      info: {
        title: this.printData.detail.RECEIPT_NO,
        fileName: this.printData.detail.RECEIPT_NO,
      },
    }
    pdfMake.createPdf(documentDefinition).open();
  }

}
